export const GITHUB_USERNAME = "Jarriola989";
export const HOMBOUND_ORG = "HomBound";
export const GITHUB_TOKEN = process.env.REACT_APP_GITHUB_TOKEN;

export const PROJECT_TYPE = {
  professional: "Professional",
  personal: "Personal",
};

export const FEATURE_TYPE = {
  api: "API",
  ui: "UI",
};

export const LANGUAGE = {
  javascript: "Javascript",
  typescript: "Typescript",
  jsx: "JSX",
  java: "Java",
  html: "HTML5",
  css: "CSS3",
  sass: "SASS",
  graphql: "GraphQL",
  python: "Python",
  c: "C++",
  csharp: "C#",
  sql: "SQL",
};

export const FRAMEWORK = {
  react: "ReactJS",
  node: "NodeJS",
  express: "Express",
  spring: "Spring",
  flask: "Flask",
};

export const DATABASE = {
  postgresql: "PostgreSQL",
  sqlserver: "SQL Server",
  mysql: "MySQL",
  mongo: "MongoDB",
  redis: "Redis",
};

export const STACK = {
  sequelize: "Sequelize",
  prisma: "Prisma",
  docker: "Docker",
  unity: "Unity",
  aws: "AWS",
};
